export default {
    inserted: function (el, binding, vnode) {
        // const stickyPos = el.offsetTop;
        const stickyPos = 0;

        const Scroll = function() {
            if(window.pageYOffset > stickyPos) {
                el.classList.add('sticky');
                document.body.classList.add('has-sticky');
            } else {
                if(el.classList.contains('sticky')) {
                    el.classList.remove('sticky');
                    if(document.body.classList.contains('has-sticky')) {
                        document.body.classList.remove('has-sticky');
                    }
                }
            }
        };

        // detect if have child - sticky logo
        if(el.querySelector('.sticky__logo')) {
            const stickyParent = el.querySelector('.c-top-nav__logo');
            stickyParent.classList.add('does-fade-out');
            const stickylogo = el.querySelector('.sticky__logo img');
            stickylogo.style.cssText = 'display: block; opacity: 0;';
        }

        window.onscroll = Scroll;
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/sticky-header.js